import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=3c8100cc&"
import script from "./Agent.vue?vue&type=script&lang=js&"
export * from "./Agent.vue?vue&type=script&lang=js&"
import style0 from "./Agent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8100cc')) {
      api.createRecord('3c8100cc', component.options)
    } else {
      api.reload('3c8100cc', component.options)
    }
    module.hot.accept("./Agent.vue?vue&type=template&id=3c8100cc&", function () {
      api.rerender('3c8100cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Agent.vue"
export default component.exports